import axios from 'axios';
import utils from '../utils';
export default {
    load: function load(options) {
        return new Promise(function (resolve) {
            var cameras = [];
            var makeurl = function makeurl() {
                var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/cameras';
                var additional_params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var address = ''.concat(options.proto || '//').concat(options.host).concat(options.port ? ':' + options.port : '');
                var params = utils.extendArray({ authorization: 'Basic '.concat(btoa(''.concat(options.user, ':').concat(options.password))) }, additional_params);
                var url_params = [];
                for (var key in params) {
                    if (params.hasOwnProperty(key)) {
                        url_params.push(''.concat(key, '=').concat(encodeURIComponent(params[key])));
                    }
                }
                return ''.concat(address).concat(path, '?').concat(url_params.join('&'));
            };
            var headers = { 'Accept': 'application/json' };
            axios.get(makeurl(), { headers: headers }).then(function (res) {
                var channels = [options.channels === 0 && [0] || options.channels || []].reduce(function (flat, current) {
                    return flat.concat(current);
                }, []);
                cameras = [].concat.apply([], res.data).map(function (val, index) {
                    if (channels.length == 0 || channels.indexOf(index) >= 0 || channels.indexOf(/cameras\/(\d+)/i.exec(val.uri)[1]) >= 0 || channels.indexOf(val.name) >= 0) {
                        return {
                            name: utils.makevalue(options.name, index, val.name),
                            image: utils.makevalue(options.image, index, makeurl(val['image-uri'])),
                            quality: [
                                {
                                    name: 'HD',
                                    url: makeurl(''.concat(val['streaming-uri'], '/main.m3u8'))
                                },
                                {
                                    name: 'SD',
                                    url: makeurl(''.concat(val['streaming-uri'], '/sub.m3u8'))
                                }
                            ]
                        };
                    }
                }).filter(function (x) {
                    return x;
                });
                resolve(cameras);
            });
        });
    }
};